import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { NgxSpinnerService } from 'ngx-spinner';

import {
  FormModeEnum,
  NotificationService,
  ModalService,
  BackendService,
  TableActionParams,
} from 'beyond-util';

import { SifarnikBase } from '../sifarnik-base/sifarnik-base';
import { BackendService as RtsBackendService } from '../../../services/backend.service';
import { EndpointTypes } from '../../../enums/enpoint-types.enum';
import { FormCode } from '../../../enums/form-code.enum';
import { FormName } from '../../../enums/form-name.enum';
import { EnumService } from '../../../services/enum.service';

@Component({
  selector: 'app-banke',
  templateUrl: './banke.component.html',
})
export class BankeComponent extends SifarnikBase implements OnInit, OnDestroy {
  private _subscriptions: Array<Subscription> = [];
  private _data: Array<any>;
  public showDetails = false;

  constructor(
    protected _backendService: BackendService,
    protected _modalService: ModalService,
    protected _notificationService: NotificationService,
    private _enumService: EnumService,
    private _rtsBackendService: RtsBackendService,
    private _spinner: NgxSpinnerService
  ) {
    super(_backendService, _modalService, _notificationService);
  }

  ngOnInit() {
    setTimeout(() => {
      this._spinner.show();
      super.ngOnInit();
    });
  }

  ngOnDestroy() {
    this._subscriptions.forEach((s: Subscription) => s.unsubscribe());
  }

  changeName() {
    if (typeof this.order === 'undefined') {
      return;
    }

    if (this.order.hasOwnProperty('naziv')) {
      this.name = this.order.naziv;
    } else if (this.mode === FormModeEnum.Add) {
      this.name = 'Nova banka';
    } else if (this.order.hasOwnProperty('id')) {
      this.name = 'Banke';
    }
  }

  loadSettings() {
    this._subscriptions.push(
      this._rtsBackendService
        .fetchSettings(
          FormCode.MSKURS_BNK,
          FormName.SifarnikBanaka,
          EndpointTypes.AllEntities,
          this.filterQuery
        )
        .subscribe(data => {
          this._spinner.hide();

          if (!this.settingsTable) {
            this.setSettings(data['Settings']);
          }

          this._data = data['ServiceData'];
          this.setId(this.orderList);
          this.orderList = this.setRbr(this._data);
          this.setAllFields();
          this.refreshTable();
        })
    );
  }

  addOrder() {
    this._spinner.show();
    const payload = { ...this.order };
    delete payload.id;
    this._subscriptions.push(
      this._rtsBackendService
        .save(FormCode.MSKURS_BNK, FormName.SifarnikBanaka, payload)
        .subscribe(() => {
          this.loadSettings();
          this._enumService.fetchBanke(true);
        })
    );
  }

  updateOrder() {
    this._spinner.show();
    this.order.rbr = this.order.Id;

    const payload = { ...this.order };
    delete payload.id;
    this._subscriptions.push(
      this._rtsBackendService
        .update(FormCode.MSKURS_BNK, FormName.SifarnikBanaka, payload)
        .subscribe(() => {
          this.loadSettings();
          this._enumService.fetchBanke(true);
        })
    );
  }

  onDeleteConfirm() {
    this._spinner.show();
    this._subscriptions.push(
      this._rtsBackendService
        .delete(FormCode.MSKURS_BNK, FormName.SifarnikBanaka, this.order.Id)
        .subscribe((data: any) => {
          this.loadSettings();
          const message = data.ServiceData
            ? 'Uspešno brisanje'
            : 'Nije moguće obrisati stavku.';
          this._enumService.fetchBanke(true);
          this._notificationService.openNoty(message);
        })
    );
  }

  onTableActionUpdate(event: TableActionParams) {
    super.onTableActionUpdate(event);
    this.updateOrder();
  }

  onTableInlineSave() {
    this.addOrder();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/banke/banke.component.ts